import { type MouseEvent, useCallback, useState } from 'react'

export function useInfoPopover() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const openPopover = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      setAnchorEl(e.currentTarget || e.target)
    },
    [setAnchorEl],
  )

  const closePopover = useCallback(() => {
    setAnchorEl(null)
  }, [setAnchorEl])

  return {
    open,
    openPopover,
    closePopover,
    anchorEl,
  }
}
